// packages/ui/src/utils/use-mobile.ts
import * as React from "react";

function useMediaQuery(query: string) {
  const getSnapshot = () => {
    if (typeof window === "undefined" || typeof window.matchMedia !== "function") return false;
    return window.matchMedia(query).matches;
  };

  const subscribe = (callback: () => void) => {
    if (typeof window === "undefined" || typeof window.matchMedia !== "function") return () => {};
    const mql = window.matchMedia(query);

    const handler = () => callback();

    if (mql.addEventListener) {
      mql.addEventListener("change", handler);
      return () => mql.removeEventListener("change", handler);
    }

    mql.addListener?.(handler);
    return () => mql.removeListener?.(handler);
  };

  return React.useSyncExternalStore(subscribe, getSnapshot, () => false);
}

export const MOBILE_BREAKPOINT = 768;

const mobileMediaQuery = (breakpoint: number = MOBILE_BREAKPOINT) => `(max-width: ${breakpoint - 1}px)`;

/**
 * One-shot for non-React contexts (TipTap extensions, plain helpers) that can't call the `useIsMobile` hook.
 */
export function isMobileViewport(breakpoint: number = MOBILE_BREAKPOINT): boolean {
  if (typeof window === "undefined" || typeof window.matchMedia !== "function") return false;
  return window.matchMedia(mobileMediaQuery(breakpoint)).matches;
}

export function useIsMobile(breakpoint: number = MOBILE_BREAKPOINT) {
  return useMediaQuery(mobileMediaQuery(breakpoint));
}
